/// <reference types="google.maps" />
import { Component, OnInit, Input, OnChanges, Output, EventEmitter, Inject, SimpleChanges, OnDestroy, ElementRef, ViewChild, Optional } from '@angular/core';
import { CurrencyPipe, DOCUMENT } from '@angular/common';
import { DataStoreService, EnvironmentConfig, GeneralService, IUser, Listing, ListingService } from '@clooper/core';
import { Loader } from '@googlemaps/js-api-loader';
import * as uuid from 'uuid';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-property-search-map',
  templateUrl: './property-search-map.component.html',
  styleUrls: ['./property-search-map.component.scss'],
  providers: [CurrencyPipe],
})
export class PropertySearchMapComponent implements OnChanges, OnInit, OnDestroy {

  @ViewChild("listingsection") set listingsectioncontent(content: any) {
    if (content) {
      this.listingsection = content;
    }
  }

  @ViewChild("listingsectionmobile") set listingsectionmobilecontent(content: any) {
    if (content) {
      this.listingsectionmobile = content;
    }
  }

  private markers: any[] = [];
  private loader: any;
  private map: google.maps.Map;
  private geocoder: google.maps.Geocoder;
  private infoWindow: google.maps.InfoWindow;
  private listingsection: ElementRef;
  private listingsectionmobile: ElementRef;
  private markersCluster: MarkerClusterer;


  clickedMarker: google.maps.Marker;
  selectedListing: Listing
  queryParams = new BehaviorSubject<{ latlng: any, page: number, radius: number, size: number }>((null as any));
  queryParamsSubs: Subscription
  routerSubs: Subscription
  dragend: boolean = false
  innerHeight: number = window.innerHeight
  popupFlag: boolean;
  searchMapFlag: boolean = false;


  @Input() listings: Listing[];
  @Input() endpoint: string;
  @Input() offsetMap: boolean;
  @Input() count: number | undefined;
  @Input() favoriteReturn: any;


  @Output() geocoded: EventEmitter<{ latlng: any, [x: string]: any }> = new EventEmitter();
  @Output() resource: EventEmitter<Listing[]> = new EventEmitter();
  @Output() showMore: EventEmitter<any> = new EventEmitter();
  @Output() launchModal: EventEmitter<any> = new EventEmitter();


  id = 'm' + uuid.v4();
  user: IUser

  constructor(
    private config: EnvironmentConfig,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private listingService: ListingService,
    private activatedRoute: ActivatedRoute,
    private currencyPipe: CurrencyPipe,
  ) {
    this.loader = new Loader({
      apiKey: this.config.google_api_key as string,
      libraries: ['places'],
      version: 'weekly'
    });
  }

  ngOnInit() {
    scroll({
      top: 0,
      behavior: 'smooth'
    });
    this.loadMap()
      const params: any = { ...this.activatedRoute.snapshot.queryParams };
      console.log(params)
    this.queryParamsSubs = this.queryParams
      .pipe(
        filter((res) => res !== null),
        switchMap(
          (queryParams) => {
            this.router.navigate([],
              {
                relativeTo: this.activatedRoute,
                queryParams: params,
                // queryParamsHandling: 'merge',

              });
            return this.listingService.search(queryParams as unknown as HttpParams)
          }
        )
      ).
      subscribe(
        (res) => {
          this.resource.emit(res)
        }
      )

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listings?.previousValue) {
      if (changes.listings?.currentValue[0] !== changes.listings?.previousValue[0]) {
        this.removePreviousMarkers()
        this.getListingsAndSetCenter()
      }
    }

  }

  ngOnDestroy(): void {
    this.queryParamsSubs.unsubscribe()
  }

  removePreviousMarkers() {
    if (this.markers) {
      for (var j = 0; j < this.markers.length; j++) {
        this.markers[j].marker.setMap(null);
      }
      this.markers.length = 0;
      this.markersCluster.clearMarkers();

    }
  }

  loadMap() {
    this.loader.load().then(() => {
      this.clickedMarker = new google.maps.Marker()


      // City-level search map style — clean base, hotel markers are the content
      const citySearchStyle: google.maps.MapTypeStyle[] = [
        // Hide clutter — users only care about their hotels, not restaurants/banks/transit icons
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        { featureType: "transit", stylers: [{ visibility: "off" }] },
        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },

        // Soften the overall palette
        { elementType: "geometry", stylers: [{ color: "#F5F5F5" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#F5F5F5" }] },

        // Roads — clean white with subtle hierarchy
        { featureType: "road", elementType: "geometry", stylers: [{ color: "#FFFFFF" }] },
        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9E9E9E" }] },
        { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#DADADA" }] },
        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },

        // Water — calm blue that harmonises with Clooper palette
        { featureType: "water", elementType: "geometry", stylers: [{ color: "#C9E4F0" }] },
        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9E9E9E" }] },

        // Parks — very faint Clooper-green tint
        { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#FAFAFA" }] },
        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#E8F3EE" }] },
        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#7B9A8A" }] },

        // Admin borders — subtle
        { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#D0D4D8" }, { weight: 0.4 }] },
      ];


      this.map = new google.maps.Map(this.document.getElementById(this.id) as HTMLElement, {
        zoom: 14,
        mapTypeControl: false,
        streetViewControl: false,
        clickableIcons: false,
        styles: citySearchStyle,
        gestureHandling: 'greedy'

      });

      this.infoWindow = new google.maps.InfoWindow(
        {
          content: document.getElementById("content"),
          // disableAutoPan: true

        }
      );


      this.getListingsAndSetCenter()

      this.geocoder = new google.maps.Geocoder();

      ///Event for center changed
      google.maps.event.addListener(this.map, "zoom_changed", () => {
        if (this.searchMapFlag) {
          this.triggerMapSearch();
        }
      });
      ///Event for center changed
      google.maps.event.addListener(this.map, "dragend", () => {
        if (this.searchMapFlag) {
          this.triggerMapSearch()
        }
      });

    });
  }

  triggerMapSearch() {
    const lat = this.map.getCenter()?.lat()
    const lng = this.map.getCenter()?.lng()

    let page = 1
    let size = 40
    let latlng = [lat, lng].join(',');
    console.log(latlng, 'new')
    // let radius = 24854.848 / (2 ^ (this.map.getZoom() || 1))
    //TODO Researh more accurate conversion of zoom level to miles
    let radius = (248.848 / 2 ^ (this.map.getZoom() || 1)) * 2
    // let radius = 10
          const params: any = { ...this.activatedRoute.snapshot.queryParams };
      console.log(params)

      const {latlng: lg, page: pg, size: sz, radius: rd, ...rest} = params

    const queryParams = { latlng, page, size, radius, ...rest }
    this.queryParams.next(queryParams)
    this.dragend = true
    this.map.panTo({ lat: lat || 51.5072, lng: lng || 0.1276 });
  }

  geocode(address: string) {
    if (address !== '' && address !== undefined) {
      const map = this.map;
      this.geocoder.geocode({ address }, (results: any, status) => {
        if (status === 'OK') {
          const { geometry, address_components } = results[0];
          const latlng: google.maps.LatLng = geometry.location;
          map.setCenter(latlng);
          const marker: google.maps.Marker = new google.maps.Marker({ map, position: latlng });
          const components = address_components.slice(-4).map((l: any) => l.long_name);
          let [city,] = components;
          const [, locality, state, country] = components;
          if (city === state && city !== locality) {
            city = locality;
          }
          this.geocoded.emit({ latlng: latlng.toJSON(), city, state, country });
        } else {
        }
      });
    }
  }

  getListingsAndSetCenter() {
    this.listings.forEach((listing, i) => {
      this.createListingMarker(listing, i)
    })

    let clusterMarkers = this.markers.map((item) => {
      return item.marker
    })

    const CLUSTER_ICON = {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_28_63)"><path d="M39 17.5C39 27.165 31.165 35 21.5 35C11.835 35 4 27.165 4 17.5C4 7.83502 11.835 0 21.5 0C31.165 0 39 7.83502 39 17.5Z" fill="white"/><path d="M38.5 17.5C38.5 26.8888 30.8888 34.5 21.5 34.5C12.1112 34.5 4.5 26.8888 4.5 17.5C4.5 8.11116 12.1112 0.5 21.5 0.5C30.8888 0.5 38.5 8.11116 38.5 17.5Z" stroke="black"/></g><defs><filter id="filter0_d_28_63" x="0" y="0" width="43" height="43" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_28_63"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_28_63" result="shape"/></filter></defs></svg>'),
      labelOrigin: new google.maps.Point(21, 19)
    }

    const renderer = {
      render({ count, position }: any) {
        return new google.maps.Marker({

          label: { text: String(count), color: "black", fontSize: "12px", },
          position,
          icon: CLUSTER_ICON
          // zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        })
      }
    }


    this.markersCluster = new MarkerClusterer({ markers: clusterMarkers, map: this.map, renderer });
    this.markersCluster.addListener('click', () => {
      //Remove opened infoWindow
      this.closeListingPopup()

    })



    if (this.dragend) {
      this.selectedListing = this.listings[0]
      this.dragend = false

    } else {
      let first_listing = this.listings[0]
      this.selectedListing = this.listings[0]
      let center = this.getLatLng(first_listing)
      this.map.setCenter(center);
    }


    this.markers.length ? this.setClickedMarker(this.markers[0]?.marker, this.listings[0]) : null

    // this.listingsection.nativeElement.scrollTop = 0
    // this.listingsection.nativeElement.scrollLeft = 0
    this.listingsection.nativeElement.scrollTo({
      top: 0,
      // behavior: 'smooth'
    });
    this.listingsectionmobile.nativeElement.scrollTo({
      left: 0,
      // behavior: 'smooth'
    });

  }

  createListingMarker(listing: Listing, i: number,) {

    const WHITE_MARKER = {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg width="81" height="51" viewBox="0 0 81 51" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_304_3)"><path d="M55.5 4H25.5C15.835 4 8 11.835 8 21.5C8 31.165 15.835 39 25.5 39H55.5C65.165 39 73 31.165 73 21.5C73 11.835 65.165 4 55.5 4Z" fill="white"/></g><defs><filter id="filter0_d_304_3" x="0" y="0" width="81" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.12 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_304_3"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_304_3" result="shape"/></filter></defs></svg>'),
      fillColor: "#51B496",
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 2,
      anchor: new google.maps.Point(15, 30),
      labelOrigin: new google.maps.Point(40, 23)

    }



    const label = {
      text: this.currencyPipe.transform((listing.room || listing.property).rent?.amount, listing.rent?.currency, true, '1.0-0') + "",
      fontWeight: "bold",
      color: 'black'
    }

    let pos: google.maps.LatLngLiteral
    if (listing.location?.coordinates) {
      pos = { lat: this.offsetMarker(listing.location?.coordinates[0]) || 51.5072, lng: this.offsetMarker(listing.location?.coordinates[1]) || 0.1276 }
    } else {
      pos = { lat: this.offsetMarker((listing as any).location[0]) || 51.5072, lng: this.offsetMarker((listing as any).location[1]) || 0.1276 }
    }
    const marker: google.maps.Marker = new google.maps.Marker({
      map: this.map, position: pos, icon: WHITE_MARKER, label,
    });
    if (i == 0) {
      marker.setZIndex(this.markers.length + 1)
    }

    this.markers.push({ marker, listing })


    //Event for marker mouse over
    google.maps.event.addListener(marker, 'mouseover', () => {
      if (marker !== this.clickedMarker) {
        this.setMouseOverMarker(marker, listing)
      }

    });

    //Event for marker mouse out
    google.maps.event.addListener(marker, 'mouseout', () => {
      if (marker !== this.clickedMarker) {
        this.setMouseOutMarker(marker, listing, 0)
      }

    });


    //Event for marker click
    google.maps.event.addListener(marker, 'click', ((marker, infoWindow) => {
      return () => {

        for (var j = 0; j < this.markers.length; j++) {
          this.markers[j].marker.setIcon(WHITE_MARKER);
          this.markers[j].marker.setZIndex(j);
          this.markers[j].marker.setLabel({
            text: this.currencyPipe.transform((this.markers[j].listing.room || this.markers[j].listing.property).rent?.amount, (this.markers[j].listing.room || this.markers[j].listing.property).rent?.currency, true, '1.0-0') + "",
            fontWeight: "bold",
            color: 'black',

          })
        }
        this.setClickedMarker(marker, listing)
        this.popupFlag = true
        this.selectedListing = listing
        let options = {
          pixelOffset: new google.maps.Size(0, 25)
        }
        infoWindow.open({
          anchor: marker,
          map: this.map,
          shouldFocus: false,

        });
        infoWindow.setOptions(options)
      }

    })(marker, this.infoWindow));

  }

  setClickedMarker(marker: google.maps.Marker, listing: Listing) {
    const BlACK_MARKER = {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg width="81" height="51" viewBox="0 0 81 51" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_304_3)"><path d="M55.5 4H25.5C15.835 4 8 11.835 8 21.5C8 31.165 15.835 39 25.5 39H55.5C65.165 39 73 31.165 73 21.5C73 11.835 65.165 4 55.5 4Z" fill="black"/></g><defs><filter id="filter0_d_304_3" x="0" y="0" width="81" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.12 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_304_3"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_304_3" result="shape"/></filter></defs></svg>'),
      fillColor: "#51B496",
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 2,
      anchor: new google.maps.Point(15, 30),
      labelOrigin: new google.maps.Point(40, 23)

    }
    marker.setIcon(BlACK_MARKER);
    marker.setLabel({
      text: this.currencyPipe.transform((listing.room || listing.property).rent?.amount, listing.rent?.currency, true, '1.0-0') + "",
      fontWeight: "bold",
      color: 'white'
    })
    marker.setZIndex(this.markers.length + 1)
    this.clickedMarker = marker
    this.selectedListing = listing
    this.listingsectionmobile.nativeElement.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  }

  setMouseOutMarker(marker: google.maps.Marker, listing: Listing, i: number) {
    const WHITE_MARKER = {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg width="81" height="51" viewBox="0 0 81 51" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_304_3)"><path d="M55.5 4H25.5C15.835 4 8 11.835 8 21.5C8 31.165 15.835 39 25.5 39H55.5C65.165 39 73 31.165 73 21.5C73 11.835 65.165 4 55.5 4Z" fill="white"/></g><defs><filter id="filter0_d_304_3" x="0" y="0" width="81" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.12 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_304_3"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_304_3" result="shape"/></filter></defs></svg>'),
      fillColor: "#51B496",
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 2,
      anchor: new google.maps.Point(15, 30),
      labelOrigin: new google.maps.Point(40, 23)

    }

    marker.setIcon(WHITE_MARKER);

    const label = {
      text: this.currencyPipe.transform((listing.room || listing.property).rent?.amount, listing.rent?.currency, true, '1.0-0') + "",
      fontWeight: "bold",
      color: 'black',
    }

    marker.setLabel(label)
    marker.setZIndex(i)
  }

  setMouseOverMarker(marker: google.maps.Marker, listing: Listing) {

    const GREY_MARKER = {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg width="81" height="51" viewBox="0 0 81 51" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_304_3)"><path d="M55.5 4H25.5C15.835 4 8 11.835 8 21.5C8 31.165 15.835 39 25.5 39H55.5C65.165 39 73 31.165 73 21.5C73 11.835 65.165 4 55.5 4Z" fill="#EEEEEE"/></g><defs><filter id="filter0_d_304_3" x="0" y="0" width="81" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.12 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_304_3"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_304_3" result="shape"/></filter></defs></svg>'),
      fillColor: "#51B496",
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 2,
      anchor: new google.maps.Point(15, 30),
      labelOrigin: new google.maps.Point(40, 23)

    }
    marker.setIcon(GREY_MARKER);
    const label = {
      text: this.currencyPipe.transform((listing.room || listing.property).rent?.amount, listing.rent?.currency, true, '1.0-0') + "",
      fontWeight: "bold",
      color: 'black',

    }
    marker.setLabel(label)
    for (var j = 0; j < this.markers.length; j++) {
      this.markers[j].marker.setZIndex(j);
    }
    this.clickedMarker.setZIndex(this.markers.length + 1)

    marker.setZIndex(this.markers.length + 2)
  }

  getOtherListings(listings: Listing[]) {
    return listings.filter(
      (listing) => {
        return (listing.id || listing._id) !== (this.selectedListing?.id || this.selectedListing?._id)
      }
    )
  }
  onListingHovered(listing: Listing) {
    // this.setListingAsCenter(listing)
    let marker = this.markers.find(
      (marker) => {
        return ((marker.listing.id || marker.listing._id) == (listing?.id || listing?._id))
      }
    )
    for (var j = 0; j < this.markers.length; j++) {
      if (this.markers[j].marker !== this.clickedMarker)
        this.setMouseOutMarker(this.markers[j].marker, this.markers[j].listing, j)
    }
    if (marker?.marker !== this.clickedMarker) {
      this.setMouseOverMarker(marker.marker, marker.listing)
    }

  }

  setListingAsCenter(listing: Listing) {
    let center = this.getLatLng(listing)
    this.map.panTo(center);
  }

  getLatLng(listing: Listing) {
    let latlng
    if (listing?.location?.coordinates) {
      latlng = { lat: listing.location?.coordinates[0] || 51.5072, lng: listing.location?.coordinates[1] || 0.1276 }
    } else {
      latlng = { lat: (listing as any)?.location[0] || 51.5072, lng: (listing as any)?.location[1] || 0.1276 }
    }
    return latlng
  }

  closeListingPopup() {
    // this.selectedListing = Listing
    this.infoWindow?.close()
  }

  toggleMapSearch() {
    this.searchMapFlag = !this.searchMapFlag
  }

  offsetMarker(value: number) {
    return value + (Math.random() - 1) / 1500;
  }

  toggleFavouriteProperty(event: any) {

    this.launchModal.emit(event)

  }
}
